export default __webpack_public_path__ + "static/media/plane.1cf4993e.svg";